export default theme => ({
  dayPickerRangeContainer: {
    flexGrow: 1,
    '& .CalendarDay__default': {
      color: 'var(--card-foreground)',
      backgroundColor: 'var(--card)',
      borderColor: 'var(--border)',
      '&:hover': {
        backgroundColor: 'var(--accent)'
      }
    },
    // '& .CalendarDay__default:hover': {
    //   backgroundColor: 'var(--accent)'
    // },
    '& .DayPickerNavigation_svg__horizontal': {
      fill: 'var(--muted-foreground)',
      '&:hover': {
        fill: 'var(--card-foreground)'
      }
    },
    '& .CalendarDay__selected_span, .CalendarDay__hovered_span:hover, .CalendarDay__hovered_span':
      {
        background: 'color-mix(in oklab, var(--primary) 10%, transparent)',
        color: 'var(--card-foreground)',
        border: `1px solid var(--card)`
      },
    '& .CalendarDay__selected': {
      background: 'var(--primary)',
      color: 'var(--primary-foreground)',
      border: `1px solid var(--card)`
    },
    // Calendar left and right arrows
    '& .DayPickerNavigation_button': {
      border: 'none',
      '&:focus': {
        outline: 'none'
      }
    }
  }
});
